/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Frontrow_Point_2Inputs */

const en_frontrow_point_2 = /** @type {(inputs: Frontrow_Point_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The order confirmation accepted, with a trace`)
};

/**
* | output |
* | --- |
* | "The order confirmation accepted, with a trace" |
*
* @param {Frontrow_Point_2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const frontrow_point_2 = /** @type {((inputs?: Frontrow_Point_2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Frontrow_Point_2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_frontrow_point_2(inputs)
});